<template>
  <div  :style="{'width': '1880px', height: (height - 82) + 'px'}" style="margin: 0 auto">
    <div class="diagram sub-left" style="margin: 0 auto;width: 100%;position: relative">
      <div style="z-index: 998;position: absolute;left: 1rem;top: 3rem" class="table-size">
        <div class="main-table D01" style="height: 7.98rem">
          <div class="JL">
            <div class="main-table-row IA"  >
              <span class="main-table-cell" style="flex: auto">1ES环境参数（1）</span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">温度</span>
              <span class="main-table-cell" style="flex: auto" >{{sensorCompute('ES1T02', 0)}}</span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">湿度</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES1T02', 1)}}</span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">烟雾</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES1Y02', 2)}}</span>
            </div>
            <div class="main-table-row Q">
              <span class="main-table-cell">水浸</span>
              <span class="main-table-cell uc-value" style="flex: auto">{{sensorCompute('ES1S02', 3)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 12rem;top: 3rem" class="table-size">
        <div class="main-table D01" style="height: 7.98rem">
          <div class="JL">
            <div class="main-table-row IA"  >
              <span class="main-table-cell" style="flex: auto">1ES环境参数（2）</span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">温度</span>
              <span class="main-table-cell" style="flex: auto" >{{sensorCompute('ES1T01', 0)}}</span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">湿度</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES1T01', 1)}}</span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">烟雾</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES1Y01', 2)}}</span>
            </div>
            <div class="main-table-row Q">
              <span class="main-table-cell">水浸</span>
              <span class="main-table-cell uc-value" style="flex: auto">{{sensorCompute('ES1S01', 3)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div style="z-index: 998;position: absolute;left: 31rem;top: 3rem" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 48rem;top: 3rem" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 76rem;top: 3rem" class="table-size" v-if="false">
        <div class="main-table D01" style="text-align: center;color: white;line-height: 25px;font-size: 13px;border: 1px solid #656565;">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 92.5rem;top: 3rem" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value"></span>
            </div>
          </div>
        </div>
      </div>


      <img src="../../assets/img/es1.svg" alt="ES1背景图" class="bg-diagram" draggable="false" style="height: auto;position: absolute;left: 0;top: 0">
      <div>
        <SignalNode node-title="D1-2AN12" type="1" info="柴发进线柜" :context="context" node-style="position: absolute;width: 5.5rem;height: auto;left: 72.66rem;top: 28.5rem;background-color: transparent"></SignalNode>
        <SignalNode node-title="J441" info="441进线隔离小车" node-style="left: 28.75rem;top:3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode node-title="J442" info="1-#2变压器422开关小车" node-style="left: 45.29rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode node-title="J321" info="321进线隔离小车" node-style="left: 73.73rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode node-title="J322" info="1-#1变压器322开关小车" node-style="left: 90.29rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>

        <SignalNode node-title="D1-2AN1" info="1-#2变压器进线柜" :context="context" node-style="left: 4.043rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN2" info="动态自动无功补偿" :context="context" node-style="left: 6.413rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN3" info="动态自动无功补偿" :context="context" node-style="left: 9.49rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN4" info="有源滤波装置" :context="context" node-style="left: 13.47rem;top: 17.2rem;"></SignalNode>

        <SignalNode :node-title="'D1-2AN5-1'" :info="'广告'" :context="context" node-style="left: 17.6rem;top: 17.2rem;"></SignalNode>
        <SignalNode :node-title="'D1-2AN5-2'" :info="'体育工艺用电（主用）'" :context="context" node-style="left: 20.41rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN5-3" :info="'安全照明（备用）'" :context="context" node-style="left: 23.04rem;top: 17.2rem;"></SignalNode>
        <SignalNode :node-title="'D1-2AN5-4'" :info="'计分及VCR（备用）'" :context="context" node-style="left: 25.5rem;top: 17.2rem;"></SignalNode>
        <SignalNode :node-title="'D1-2AN5-5'" :info="'电视转播机房（备用）'" :context="context" node-style="left: 28.05rem;top: 17.2rem;"></SignalNode>
        <SignalNode :node-title="'D1-2AN5-6'" :info="'赛事封闭评论室（主用）'" :context="context" node-style="left: 30.61rem;top: 17.2rem;"></SignalNode>
        <SignalNode :node-title="'D1-2AN5-7'" :info="'环屏用电'" :context="context" node-style="left: 33.16rem;top: 17.2rem;"></SignalNode>
        <SignalNode :node-title="'D1-2AN5-8'" :info="'媒体席位设备（备用）'" :context="context" node-style="left: 35.72rem;top: 17.2rem;"></SignalNode>
        <SignalNode :node-title="'D1-2AN5-9'" :info="'备用'" :context="context" node-style="left: 38.29rem;top: 17.2rem;"></SignalNode>
        <SignalNode :node-title="'D1-2AN5-10'" :info="'备用'" :context="context" node-style="left: 40.85rem;top: 17.2rem;"></SignalNode>


        <SignalNode node-title="D1-2AN6-1" info="电梯总箱（主用）" :context="context" node-style="left: 44.25rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN6-2" info="贵宾区电梯总箱（备用）" :context="context" node-style="left: 47.04rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN6-3" info="草坪给水系统" :context="context" node-style="left: 49.719rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN6-4" info="送排风总箱" :context="context" node-style="left: 52.16rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN6-5" info="地下通风排水系统" :context="context" node-style="left: 54.73rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN6-6" info="排风机新风机总箱" :context="context" node-style="left: 57.279rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN6-7" info="泛光照明配电箱" :context="context" node-style="left: 59.83rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN6-8" info="备用" :context="context" node-style="left: 62.36rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN6-9" info="备用" :context="context" node-style="left: 64.93rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN6-10" info="备用" :context="context" node-style="left: 67.478rem;top: 17.2rem;"></SignalNode>

        <SignalNode node-title="D1-2AN7-1" info="贵宾休息室（备用）" :context="context" node-style="left: 70.91rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN7-2" info="新闻发布区照明（主用）" :context="context" node-style="left: 73.7rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN7-3" info="照明" :context="context" node-style="left: 76.35rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN7-4" info="贵宾休息室（主用）" :context="context" node-style="left: 78.79rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN7-5" info="照明" :context="context" node-style="left: 81.35rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN7-6" info="贵宾休息室（主用）" :context="context" node-style="left: 83.91rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN7-7" info="转播设备（备用）" :context="context" node-style="left: 86.47rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN7-8" info="备用" :context="context" node-style="left: 89.04rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN7-9" info="备用" :context="context" node-style="left: 91.6rem;top: 17.2rem;"></SignalNode>

        <SignalNode node-title="D1-2AN8-1" info="站用电（主用）" :context="context" node-style="left: 94.98rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN8-2" info="普通风机总箱" :context="context" node-style="left: 97.79rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN8-3" info="弱电间电源总箱（备用）" :context="context" node-style="left: 100.44rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN8-4" info="照明总箱2" :context="context" node-style="left: 102.91rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN8-5" info="屋顶融雪电伴热" :context="context" node-style="left: 105.46rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN8-6" info="室外活动预留配电箱" :context="context" node-style="left: 108.03rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN8-7" info="备用" :context="context" node-style="left: 110.54rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN8-8" info="备用" :context="context" node-style="left: 113.1rem;top: 17.2rem;"></SignalNode>
        <SignalNode node-title="D1-2AN8-9" info="备用" :context="context" node-style="left: 115.66rem;top: 17.2rem;"></SignalNode>


        <SignalNode node-title="D1-2AN9-1" info="备用" :context="context" node-style="left: 3.723rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN9-2" info="生活水泵房" :context="context" node-style="left: 6.16rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN9-3" info="普通排水泵总箱（主用）" :context="context" node-style="left: 8.73rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN9-4" info="雨水提升泵" :context="context" node-style="left: 11.29rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN9-5" info="充电车位群控箱" :context="context" node-style="left: 13.85rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN9-6" info="备用" :context="context" node-style="left: 16.39rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN9-7" info="备用" :context="context" node-style="left: 18.95rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN9-8" info="备用" :context="context" node-style="left: 21.66rem;top: 30.47rem;"></SignalNode>

        <SignalNode node-title="D1-2AN10-1" info="消防电源箱（备用）" :context="context" node-style="left: 24.29rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN10-2" info="消防电源箱（备用）" :context="context" node-style="left: 27.1rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN10-3" info="消防电源箱（备用）" :context="context" node-style="left: 29.79rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN10-4" info="消防电源箱（备用）" :context="context" node-style="left: 32.22rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN10-5" info="备用" :context="context" node-style="left: 34.79rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN10-6" info="消防风机电源箱（备用）" :context="context" node-style="left: 37.31rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN10-7" info="备用" :context="context" node-style="left: 39.86rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN10-8" info="备用" :context="context" node-style="left: 42.45rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN10-9" info="备用" :context="context" node-style="left: 45.04rem;top: 30.47rem;"></SignalNode>

        <SignalNode node-title="D1-2AN11-1" info="消防负荷（备用）" :context="context" node-style="left: 48.1rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN11-2" info="消防电源箱（备用）" :context="context" node-style="left: 50.66rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN11-3" info="消防负荷（备用）" :context="context" node-style="left: 53.46rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN11-4" info="消防负荷（备用）" :context="context" node-style="left: 56.1rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN11-5" info="消防电源（备用）" :context="context" node-style="left: 58.56rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN11-6" info="消防电源（备用）" :context="context" node-style="left: 61.1rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN11-7" info="消防电源（备用）" :context="context" node-style="left: 63.66rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN11-8" info="备用" :context="context" node-style="left: 66.22rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN11-9" info="备用" :context="context" node-style="left: 68.79rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN11-10" info="备用" :context="context" node-style="left: 71.35rem;top: 30.47rem;"></SignalNode>

        <SignalNode node-title="D1-2AN13-1" info="场地照明（主用）" :context="context" node-style="left: 78.79rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN13-2" info="功放设备1（主用）" :context="context" node-style="left: 81.04rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN13-3" info="功放设备2（主用）" :context="context" node-style="left: 83.48rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN13-4" info="场地照明（备用）" :context="context" node-style="left: 85.79rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN13-5" info="场地照明（备用）" :context="context" node-style="left: 88.3rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN13-6" info="场地照明（主用）" :context="context" node-style="left: 90.73rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN13-7" info="场地照明（主用）" :context="context" node-style="left: 93.25rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN13-8" info="场地照明（备用）" :context="context" node-style="left: 95.66rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN13-9" info="备用" :context="context" node-style="left: 98.16rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN13-10" info="备用" :context="context" node-style="left: 100.7rem;top: 30.47rem;"></SignalNode>

        <SignalNode node-title="D1-2AN14-1" info="备用" :context="context" node-style="left: 103.47rem;top: 30.65rem;"></SignalNode>
        <SignalNode node-title="D1-2AN14-2" info="备用" :context="context" node-style="left: 105.57rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN14-3" info="备用" :context="context" node-style="left: 107.54rem;top: 30.65rem;"></SignalNode>
        <SignalNode node-title="D1-2AN14-4" info="备用" :context="context" node-style="left: 109.49rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN14-5" info="备用" :context="context" node-style="left: 111.54rem;top: 30.47rem;"></SignalNode>
        <SignalNode node-title="D1-2AN14-6" info="备用" :context="context" node-style="left: 113.73rem;top: 30.65rem;"></SignalNode>
        <SignalNode node-title="D1-2AN14-7" info="备用" :context="context" node-style="left: 115.67rem;top: 30.47rem;"></SignalNode>

        <SignalNode node-title="D1-1AN13-1" info="消防负荷（主用）" :context="context" node-style="left: 3.983rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN13-2" info="消防电源箱（主用）" :context="context" node-style="left: 6.91rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN13-3" info="消防负荷（主用）" :context="context" node-style="left: 9.6rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN13-4" info="消防负荷（主用）" :context="context" node-style="left: 12.04rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN13-5" info="消防电源（主用）" :context="context" node-style="left: 14.6rem;top: 42.656rem;;"></SignalNode>
        <SignalNode node-title="D1-1AN13-6" info="消防电源（主用）" :context="context" node-style="left: 17.16rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN13-7" info="备用" :context="context" node-style="left: 19.7rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN13-8" info="备用" :context="context" node-style="left: 22.29rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN13-9" info="备用" :context="context" node-style="left: 24.8rem;top: 42.656rem;"></SignalNode>


        <SignalNode node-title="D1-1AN12-1" info="消防电源箱（主用）" :context="context" node-style="left: 32.35rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN12-2" info="消防电源箱（主用）" :context="context" node-style="left: 35.25rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN12-3" info="消防电源箱（主用）" :context="context" node-style="left: 37.91rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN12-4" info="消防电源箱（主用）" :context="context" node-style="left: 40.35rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN12-5" info="消防风机电源箱（主用）" :context="context" node-style="left: 42.91rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN12-6" info="消防电源（主用）" :context="context" node-style="left: 45.46rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN12-7" info="备用" :context="context" node-style="left: 48.04rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN12-8" info="备用" :context="context" node-style="left: 50.6rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN12-9" info="备用" :context="context" node-style="left: 53.16rem;top: 42.656rem;"></SignalNode>

        <SignalNode node-title="D1-1AN11-1" info="室外景观" :context="context" node-style="left: 60.6rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN11-2" info="充电车位群控箱" :context="context" node-style="left: 63.27rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN11-3" info="草坪补光系统" :context="context" node-style="left: 65.73rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN11-4" info="屋顶融雪电伴热" :context="context" node-style="left: 68.29rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN11-5" info="备用" :context="context" node-style="left: 70.8rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN11-6" info="备用" :context="context" node-style="left: 73.4rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN11-7" info="备用" :context="context" node-style="left: 75.95rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN11-8" info="备用" :context="context" node-style="left: 78.48rem;top: 42.656rem;"></SignalNode>

        <SignalNode node-title="D1-1AN10" info="母联柜" :context="context" node-style="left: 84.85rem;top: 42.72rem;"></SignalNode>

        <SignalNode node-title="D1-1AN9-1" info="普通排水泵总箱（主用）" :context="context" node-style="left: 93.282rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN9-2" info="照明总箱1" :context="context" node-style="left: 96.04rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN9-3" info="普通负荷" :context="context" node-style="left: 98.73rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN9-4" info="普通负荷" :context="context" node-style="left: 101.19rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN9-5" info="弱电间电源总箱（主用）" :context="context" node-style="left: 103.75rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN9-6" info="站用电（备用）" :context="context" node-style="left: 106.29rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN9-7" info="转播设备（主用）" :context="context" node-style="left: 108.85rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN9-8" info="备用" :context="context" node-style="left: 111.4rem;top: 42.656rem;"></SignalNode>
        <SignalNode node-title="D1-1AN9-9" info="备用" :context="context" node-style="left: 113.96rem;top: 42.656rem;"></SignalNode>

        <SignalNode node-title="D1-1AN8-1" info="新闻发布区照明（备用）" :context="context" node-style="left: 3.985rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN8-2" info="照明总箱" :context="context" node-style="left: 6.685rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN8-3" info="照明" :context="context" node-style="left: 9.16rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN8-4" info="贵宾休息室（备用）" :context="context" node-style="left: 11.7rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN8-5" info="贵宾休息室（备用）" :context="context" node-style="left: 14.25rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN8-6" info="贵宾休息室（主用）" :context="context" node-style="left: 16.8rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN8-7" info="备用" :context="context" node-style="left: 19.4rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN8-8" info="备用" :context="context" node-style="left: 21.91rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN8-9" info="备用" :context="context" node-style="left: 24.48rem;top: 52.95rem;"></SignalNode>

        <SignalNode node-title="D1-1AN7-1" info="草坪补光系统" :context="context" node-style="left: 26.92rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN7-2" info="雨水处理" :context="context" node-style="left: 29.59rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN7-3" info="地下通风排水系统" :context="context" node-style="left: 32.04rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN7-4" info="送排新风机总箱" :context="context" node-style="left: 34.6rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN7-5" info="电梯总箱（备用）" :context="context" node-style="left: 37.16rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN7-6" info="贵宾区电梯总箱（主用）" :context="context" node-style="left: 39.71rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN7-7" info="备用" :context="context" node-style="left: 42.28rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN7-8" info="备用" :context="context" node-style="left: 44.8rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN7-9" info="备用" :context="context" node-style="left: 47.4rem;top: 52.95rem;"></SignalNode>

        <SignalNode node-title="D1-1AN6-1" info="赛事封闭评论室（备用）"  :context="context" node-style="left: 50.04rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN6-2" info="体育工艺用电（备用）" :context="context" node-style="left: 52.85rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN6-3" info="场地照明（主用）" :context="context" node-style="left: 55.5rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN6-4" info="场地照明（备用）" :context="context" node-style="left: 57.97rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN6-5" info="场地照明（主用）" :context="context" node-style="left: 60.53rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN6-6" info="计分及VCR（主用）" :context="context" node-style="left: 63.09rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN6-7" info="环屏用电" :context="context" node-style="left: 65.64rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN6-8" info="备用" :context="context" node-style="left: 68.17rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN6-9" info="备用" :context="context" node-style="left: 70.75rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN6-10" info="备用" :context="context" node-style="left: 73.25rem;top: 52.95rem;"></SignalNode>

        <SignalNode node-title="D1-1AN5-1" info="功放设备1（备用）" :context="context" node-style="left: 76.16rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN5-2" info="功放设备2（备用）" :context="context" node-style="left: 78.97rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN5-3" info="电视转播机房（主用）" :context="context" node-style="left: 81.6rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN5-4" info="场地照明（备用）" :context="context" node-style="left: 84.05rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN5-5" info="场地照明（主用）" :context="context" node-style="left: 86.6rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN5-6" info="场地照明（备用）" :context="context" node-style="left: 89.16rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN5-7" info="安全照明（主用）" :context="context" node-style="left: 91.7rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN5-8" info="媒体席位设备（备用）" :context="context" node-style="left: 94.29rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN5-9" info="备用" :context="context" node-style="left: 96.85rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN5-10" info="备用" :context="context" node-style="left: 99.4rem;top: 52.95rem;"></SignalNode>

        <SignalNode node-title="D1-1AN4" info="有源滤波装置" :context="context" node-style="left: 103.85rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN3" info="动态自动无功补偿" :context="context" node-style="left: 108.3rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN2" info="动态自动无功补偿" :context="context" node-style="left: 111.54rem;top: 52.95rem;"></SignalNode>
        <SignalNode node-title="D1-1AN1" info="1-#1变压器进线柜" :context="context" node-style="left: 114.35rem;top: 52.95rem;"></SignalNode>

      </div>
    </div>
  </div>
</template>

<script setup>
import {useSize} from "@/assets/js/size";
import SignalNode from "@/components/system/SignalNode";
import {ref} from "vue";
import {useRealTimeDataService} from "@/assets/js/realTimeDataService";
import {useSensorCompute} from "@/assets/js/sensorCompute";
import useUtils from "@/assets/js/utils";
const {height} = useSize();
const {alert} = useUtils();
let context = ref({})
function service(data){
  for (let key in data){
    context.value[key] = data[key];
    if (data[key]?.alert){
      alert.value['es1'] = true;
    }
  }
  context.value['alert'] = alert.value['es1'];
}
useRealTimeDataService(service, 1, {checkFR: true});
let sensorCompute = useSensorCompute(context);

</script>

<style scoped>
.diagram{
  position: relative;
  margin: 70px auto 0;
}
@media screen and (min-width: 3840px) {
  .diagram,.bg-diagram{
    width: 3840px;
  }
}
@media screen and (max-width: 3840px) {
  .diagram,.bg-diagram{
    width: 3840px;
  }
}

@media screen and (max-width: 3000px){
  .diagram,.bg-diagram{
    width: 3000px;
  }
}

@media screen and (max-width: 1920px){
  .diagram,.bg-diagram{
    width: 1920px;
  }
}

.diagram,.bg-diagram{
  width: 1920px;
}

.main-table{
  width: 9.5rem;
  height: 6.45rem;

  float:left;
  border:1px solid #666;
  text-align: center;
  color: white;
  line-height: 1.5625rem;
  font-size: 0.8125rem;
}
.main-table-row{
  width: 100%;
  height: 1.5625rem;
  line-height: 1.5625rem;
  font-size: 0.8125rem;
  border-bottom: 1px dashed grey;
  display: flex;
  flex-wrap: nowrap;
}
.main-table-row:last-child{
  border-bottom: none;
}
.main-table-cell{
  flex:0 50px;
}
.main-table-cell:nth-child(1){
  border-right: 1px dashed grey;
}
.main-table-cell:nth-child(2){
  flex:1 0px;
  font-weight: bold;
  font-size: 0.9375rem;
}
.main-table-cell:nth-child(3){
  border-left: 1px dashed grey;
  flex:0 30px;
}

.IA{
  color: #dede12
}
.IB{
  color:#0dd22d
}
.P{
  color: #00ceff;
}
.Q{
  color: #ec4cff;
}
.COS{
  color: #0d86ed ;
}
</style>